<div class="modal-header">
    <h4 class="modal-title">{{ request ? 'Editar Solicitud' : 'Nueva Solicitud' }}</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSave()">
    <mat-dialog-content class="mat-typography">
        <div class="row">
            <div class="col-12">
                <!-- Título y Descripción -->
                <ng-container *ngIf="!request; else viewTituloDescripcion">
                    <!-- Título -->
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                        <mat-label>Solicitud</mat-label>
                        <input matInput formControlName="titulo" required>
                        <mat-error *ngIf="form.get('titulo')?.hasError('required')">El nombre de la solicitud es requerida.</mat-error>
                        <mat-error *ngIf="form.get('titulo')?.hasError('minlength')">Debe tener al menos 3 caracteres.</mat-error>
                    </mat-form-field>
                    <!-- Descripción -->
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                        <mat-label>Descripción</mat-label>
                        <textarea matInput formControlName="descripcion" rows="4"></textarea>
                    </mat-form-field>
                </ng-container>
                <ng-template #viewTituloDescripcion>
                    <div class="card bg-light mb-3">
                        <div class="card-body">
                            <h4 class="card-subtitle mb-2"> Solicitud</h4>
                            <p class="card-text">{{ request?.titulo }}</p>
                           
                            <h4 class="card-subtitle mb-2">Descripción</h4>
                            <p class="card-text">{{ request?.descripcion || 'Sin descripción' }}</p>

                            <h4 class="card-subtitle mb-2">Fecha solicitud</h4>
                            <p class="card-text">{{ request?.created_at | date:'dd/MM/yyyy':"+0000" }}</p>
                        </div>
                    </div>
                </ng-template>

                <mat-form-field *ngIf="request &&  hasPermissions()" class="w-100 mb-3">
                    <mat-label>Etiquetas</mat-label>
                    <mat-chip-list #chipList aria-label="Selección de etiquetas">
                        <mat-chip *ngFor="let badge of badges" (removed)="removeBadge(badge)">
                            {{badge}}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip>
                        <input placeholder="Nueva etiqueta..." #badgeInput [formControl]="badgeCtrl"
                            [matAutocomplete]="auto" [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="addBadge($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedBadge($event)">
                        <mat-option *ngFor="let badge of filteredBadges | async" [value]="badge">
                            {{badge}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <div  class="mb-4">
                     <h3 class="mb-3">Archivos de la solicitud</h3>
                    <ngx-file-drag-drop *ngIf="!finalizada"
                        [formControl]="fileControl"
                        (valueChanged)="onFileSelected($event)"
                        class="ngx-file_f"
                        emptyPlaceholder="Arrastre o seleccione archivo">
                    </ngx-file-drag-drop>
                </div>

                 <div *ngIf="request && uploadedFiles.length > 0" class="mt-4">
                   
                    <div class="table-responsive text-nowrap">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nombre del archivo</th>
                                    <th>Subido por</th>
                                    <th>Fecha</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let file of uploadedFiles">
                                    <td>{{ file.id }}</td>
                                    <td>
                                        <a [href]="file.archivo" target="_blank">{{ file.nombre }}</a>
                                    </td>
                                    <td>{{ file.nombre_usuario }}</td>
                                    <td>{{ file.created_at | date : "dd/MM/yyyy " :"+0000" }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Campos solo para edición -->
                <div *ngIf="request &&  hasPermissions()">
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field appearance="outline" class="w-100 mb-3" >
                                <mat-label>Fecha compromiso</mat-label>
                                <input matInput [matDatepicker]="picker" formControlName="estimated_date" [disabled]="finalizada">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field appearance="outline" class="w-100 mb-3">
                                <mat-label>Usuario responsable</mat-label>
                                <mat-select formControlName="id_responsable" [disabled]="finalizada">
                                    <mat-option [value]="null">Sin asignar</mat-option>
                                    <mat-option *ngFor="let user of allUsers" [value]="user.id">
                                        {{ user.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
    
                    <mat-form-field appearance="outline" class="w-100 mb-3">
                        <mat-label>Estatus</mat-label>
                        <mat-select formControlName="status" [disabled]="finalizada">
                            <mat-option [value]="1">Pendiente</mat-option>
                            <mat-option [value]="2">En Proceso</mat-option>
                            <mat-option [value]="3">Terminada</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-stroked-button mat-dialog-close>Cancelar</button>
        <button *ngIf="!finalizada" mat-raised-button color="primary" type="submit" [disabled]="form.invalid || isLoading">
            <span *ngIf="!isLoading">Guardar</span>
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
        </button>
    </mat-dialog-actions>
</form>